import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  SxProps,
  Typography,
  styled,
} from "@mui/material";
import { ReactElement, ReactNode, useEffect, useState } from "react";

import { FlexBox } from "~frontend/components/FlexBox";
import { palette } from "~frontend/theme";
import { spacingArray } from "~frontend/util/styling";

const Accordion = styled(MuiAccordion)({
  backgroundColor: palette.lightestGray,
  padding: spacingArray([0, 7]),
});

const AccordionDetails = styled(MuiAccordionDetails)({
  padding: spacingArray([0, 0, 3]),
});

const AccordionSummary = styled(MuiAccordionSummary)({
  padding: 0,
});

export const CampaignViewAccordion = ({
  header,
  secondHeader,
  children,
  sx = {},
  expanded = undefined,
  setExpanded = undefined,
  emptyDetails = false,
  onAccordionChange,
}: {
  header: string;
  secondHeader?: string;
  children: ReactNode;
  sx?: SxProps;
  expanded?: boolean;
  setExpanded?: (expanded: boolean) => void;
  emptyDetails?: boolean;
  onAccordionChange?: () => void;
}): ReactElement => {
  const [isExpanded, setIsExpanded] = useState(expanded ?? false);
  useEffect(() => {
    setIsExpanded(expanded ?? false);
  }, [expanded]);

  return (
    <Accordion
      disableGutters
      sx={sx}
      expanded={isExpanded}
      onChange={(evt, expanded) => {
        if (setExpanded) {
          setExpanded(expanded);
        } else {
          setIsExpanded(!isExpanded);
        }
        if (onAccordionChange) {
          onAccordionChange();
        }
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <FlexBox direction="column" gap={1}>
          <Typography variant="h1Bold" component="h2">
            {header}
          </Typography>
          {secondHeader && isExpanded && (
            <Typography variant="body1">{secondHeader}</Typography>
          )}
        </FlexBox>
      </AccordionSummary>
      {!emptyDetails && <AccordionDetails>{children}</AccordionDetails>}
    </Accordion>
  );
};
